export default __webpack_public_path__ + "fog.e0851c9c4fa75ce89a95a7692439fc46.png";